import { render } from "./CreateCourseStepComponent.vue?vue&type=template&id=4685e162&scoped=true"
import script from "./CreateCourseStepComponent.vue?vue&type=script&lang=js"
export * from "./CreateCourseStepComponent.vue?vue&type=script&lang=js"

import "./CreateCourseStepComponent.vue?vue&type=style&index=0&id=4685e162&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4685e162"]])

export default __exports__